import { ITeamTypings } from '../typings/team';
import { FontSize } from '../typings/design-tokens';

import { truncate } from './truncate';

const DEFAULT_MAX_NAME_LENGTH = 12;

interface teamAttribute {
  homeName: string;
  awayName: string;
  fontSize: FontSize;
}

interface teamAttributes {
  desktop: teamAttribute;
  mobile: teamAttribute;
}

export const getTeamsAttributes = (
  home: ITeamTypings,
  away: ITeamTypings,
  roundGroup: string | null | undefined
): teamAttributes => {
  // MOBILE Team names
  const homeNameSmall =
    home.shortname && home.shortname.length > 0 ? home.shortname : truncate(home.name, DEFAULT_MAX_NAME_LENGTH);
  const awayNameSmall =
    away.shortname && away.shortname.length > 0 ? away.shortname : truncate(away.name, DEFAULT_MAX_NAME_LENGTH);

  const isTeamNameSmall =
    roundGroup && (homeNameSmall.length > DEFAULT_MAX_NAME_LENGTH || awayNameSmall.length > DEFAULT_MAX_NAME_LENGTH);

  return {
    desktop: {
      homeName: home.name,
      awayName: away.name,
      fontSize: '14',
    },
    mobile: {
      homeName: home.name.length > DEFAULT_MAX_NAME_LENGTH ? homeNameSmall : home.name,
      awayName: away.name.length > DEFAULT_MAX_NAME_LENGTH ? awayNameSmall : away.name,
      fontSize: isTeamNameSmall ? '12' : '14',
    },
  };
};
